import { Helmet } from "react-helmet";
import styled from "styled-components";
import { SCAPTCHA_ONCOMPLETE_PROP } from "../utils/constants";
import { useTranslation } from "react-i18next";

const DemoModelPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <script
          async
          src="https://api.scaptcha.com/widget/scaptcha-ui.js"
        ></script>
      </Helmet>
      <Container>
        <div className="top_box">
          <p>{t("demoPage")}</p>
        </div>
        <div className="box">
          <div
            className="s-captcha"
            data-prop-sitekey="c18e029759b44b499a0bd4f0dcb65ee8"
            data-prop-oncomplete={SCAPTCHA_ONCOMPLETE_PROP}
          />
        </div>
      </Container>
    </>
  );
};

export default DemoModelPage;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  & h1 {
    font-size: 24px;
    text-align: center;
  }

  .top_box {
    max-width: 40rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 1.5rem;
    border: none;
    outline: none;
    border-bottom-right-radius: none;
    border-bottom-left-radius: none;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    color: #ffffff;
    background: #9bc2e0;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    p {
      font-size: 18px;
      padding: 0 10px;
      text-align: center;
    }

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }
  }

  .box {
    max-width: 40rem;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 3rem 2.5rem;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    border: none;
    outline: none;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: none;
    border-top-left-radius: none;
    color: #121212;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }
  }
`;
